/**
 * Query keys for the signed-in user — in their own module so the auth provider
 * can observe the profile without importing the user hooks (which import it).
 */
export const userKeys = {
  all: ['user'] as const,
  profile: () => [...userKeys.all, 'profile'] as const,
  settings: () => [...userKeys.all, 'settings'] as const,
  onboardingStatus: () => [...userKeys.all, 'onboarding-status'] as const,
  /** W8.1 · F33 — the sixth CheckUp readiness requirement. */
  profileCompleteness: () => [...userKeys.all, 'profile-completeness'] as const,
};
